import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("button", {
      type: "button",
      class: "flex items-center gap-1 text-12px font-semibold text-red-lp-2400",
      "data-testid": "pickup-address-form-link-panduan",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openModal && _ctx.openModal(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.$t("pickupAddress.guide.link")) + " ", 1),
      _createVNode(_component_Icons, {
        name: "chevron-right",
        class: "h-3 w-3"
      })
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createVNode(_component_Modal, {
        title: _ctx.$t('pickupAddress.guide.title'),
        onClose: _ctx.closeModal
      }, null, 8, ["title", "onClose"]), [
        [_vShow, _ctx.isOpen]
      ])
    ]))
  ]))
}